module.exports = __webpack_public_path__ + "img/bgmcat.901b0307.png";